import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {useMemo, useState} from "react";
import {initialResourceItemCount} from "../utils/helpers";
import {ProductInfoAndInstallationModel} from "../models/view/productInfoAndInstallationModel";

export const useProductInfoAndInstallationQuery = () => {
    const {model: {media, primaryMedia}} = useProductDetailsQuery();
    const [showCount, setShowCount] = useState<number>(initialResourceItemCount);

    const {
        title,
        resources,
        resourceCount,
        hasResources
    } = useMemo(() => {
        return new ProductInfoAndInstallationModel(media, primaryMedia);
    }, [media, primaryMedia]);

    return {
        title,
        hasResources,
        resourceCount,
        resources: resources.slice(0, showCount),
        moreToShow: resourceCount > showCount,
        showAll: () => setShowCount(resourceCount)
    }
}